import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SnackbarProvider, MaterialDesignContent } from "notistack";
import theme from "./theme";
import App from "./App";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import { StaffAuthProvider } from "./contexts/StaffAuthContext";
import "./index.css";

// Style aligne sur ar.nouhaprint (reactjs-frontend/StyledNotification.jsx)
const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent": {
    color: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
    fontSize: "0.9rem",
    fontWeight: 500,
    padding: "12px 16px",
    maxWidth: "92vw",
    width: "fit-content",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    lineHeight: 1.25,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 12px 35px rgba(0, 0, 0, 0.2)",
    },
  },
  "&.notistack-MuiContent-success": { backgroundColor: "#6db43d" },
  "&.notistack-MuiContent-error":   { backgroundColor: "#f27c1e" },
  "&.notistack-MuiContent-warning": { backgroundColor: "#f27c1e" },
  "&.notistack-MuiContent-info":    { backgroundColor: "#333333" },
  "&.notistack-MuiContent-default": { backgroundColor: "#6db43d" },
}));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        style={{ top: "60px" }}
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
          default: StyledMaterialDesignContent,
        }}
      >
        <BrowserRouter>
          <ClientAuthProvider>
            <StaffAuthProvider>
              <App />
            </StaffAuthProvider>
          </ClientAuthProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>
);
